// API Configuration - ADMIN FRONTEND
// Environment variables from Vite (import.meta.env)

export const config = {
  // API URLs - Use relative URLs to leverage Vite proxy (proxies to backend via /api → localhost:8080)
  apiUrl: import.meta.env.VITE_API_URL || '/api',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || '',

  // Frontend URLs
  userAppUrl: import.meta.env.VITE_USER_APP_URL || 'https://app.localhost',
  adminAppUrl: import.meta.env.VITE_ADMIN_APP_URL || 'https://admin.localhost',
  websiteUrl: import.meta.env.VITE_WEBSITE_URL || 'https://localhost',

  // Environment
  env: import.meta.env.VITE_ENV || 'development',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // App settings
  appName: 'CaninCloud Admin',
  appVersion: '2.0.0',

  // Admin-specific settings
  isAdminPanel: true,

  // Token storage keys (use separate keys to avoid conflicts with user frontend)
  tokenKey: 'admin_accessToken',
  refreshTokenKey: 'admin_refreshToken',
  userKey: 'admin_currentUser',

  // Inactivity timeout (in milliseconds)
  // Admin: 5 minutes
  inactivityTimeout: 5 * 60 * 1000,  // 5 minutes (300 seconds)
  inactivityWarningTime: 20 * 1000   // Show warning 20 seconds before timeout
};

export default config;
